<!-- 我的流量页面 -->
<template>
  <div class="order">
    <div class="order-header">
      <app-header @on-click="e_goBack"
        backgroundColor="#F2F2F2"
        :title="activeTab === 'flow' ? $t('order.myFlow') : $t('order.orderList.title')"></app-header>
    </div>
    <div class="tabs-con">
      <van-tabs class="order-tabs" type="card" :color="tabColor" background="#f2f2f2" :active="activeTab" swipeable @change="tabsChange">
        <van-tab :title="$t('order.myFlow')" name="flow"></van-tab>
        <van-tab :title="$t('order.orderList.title')" name="order"></van-tab>
      </van-tabs>
    </div>
    <!-- <pull-refresh @refresh="refresh" :disabled="true"> -->
      <div class="order-data" v-show="activeTab === 'flow'">
        <div class="order-con">
          <div v-if="firstInFlag && dataList.length"
            class="order-con-flow">
            <div class="flowCon">
              <ul class="flowItem"
                :class="{'van-hairline--top': index != 0,'flowItem_long': isShowLongStyle}"
                v-for="(item, index) in dataList"
                @click="e_toDetail(item)"
                :key="index">
                <li class="title van-multi-ellipsis--l2">{{item.goodsName}}</li>
                <li class="maxCount"
                  v-if="item.a_maxCount > 1">×{{item.a_maxCount}}</li>
                <li class="flowCount" 
                 v-if="!item.extendValVos || !item.a_getValue_hideFlowSize || item.a_getValue_hideFlowSize && item.a_getValue_hideFlowSize != '1' ">{{item.a_surplusFlow.type == 'DISC' ? $t('order.remainingHighFlow') : $t("order.remainingFlow")}}：{{item.a_surplusFlow.remainFlow | filterFlow}}</li>
                <li class="timeLimit">
                  <span class="a_activeTime_name" v-show="(!isRegAndLogin && (item.status !== 'NOT_ACTIVATED' && item.isUseActive) ) || isRegAndLogin">{{item.a_activeTime.name}}：
                    <span :style="{color: item.a_activeTime.notRed ? '#999999' : '#F74E4E'}">{{item.a_activeTime.time}}</span>
                  </span>
                  <span class="flow_state flow_state_long"
                    v-if="Function_PackageTop"
                    @click.stop="e_changeState(item)"
                    :class="[item.a_state]">{{item.a_state && $t(`order.state.${item.a_state}`)}}</span>
                  <div class="timeLimit mt5" v-if="!isRegAndLogin && (item.inUse != '1' || (!Function_PackageTop && item.inUse == '1'))">
                    {{ item.status !== 'NOT_ACTIVATED' && item.isUseActive ? $t('home.package_useing') : $t('home.unused') }}
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div v-if="firstInFlag && !dataList.length"
            class="order-con-none">
            <div class="title">{{$t('order.noneFlow')}}</div>
            <div class="desc">{{$t('order.noneFlowTip')}}</div>
            <van-button class="buyBtn" round block type="info" @click="gotoBuy()">{{ $t('order.buyPackFlow') }}</van-button>
          </div>
          <div class="order-con-toInvalid"
            @click="e_toInvalidFlow()">
            {{$t('order.checkInvalidFlow')}}
            <van-icon :name="$i18n.locale ==='ar-AE' ? 'arrow-left' : 'arrow'" />
          </div>
        </div>
        <div class="order-use-intro">
          <div class="box-title">{{$t('packages.detail.use_intro')}}</div>
          <ul class="order-desc" v-show="Module_UseIntroTips" >
            <li>• {{$t("order.useIntro.tip1")}}</li>
            <li>• {{$t("order.useIntro.tip2")}}</li>
            <li>• {{$t("order.useIntro.tip3")}}</li>
          </ul>
        </div>
      </div>
    <!-- </pull-refresh> -->

    <OrderList v-show="activeTab === 'order'"></OrderList>
  </div>
</template>

<script>
import cookie from "../../utils/cookie";
import { keepTwodecimalFixed } from "../../utils/util";
import checkProjectConfig from '@/lib/checkProjectConfig';
import { Tab, Tabs } from "vant";
import OrderList from "./components/OrderListPage.vue";

export default {
  name: "OrderListIndex",
    components: {
    vanTabs: Tabs,
    vanTab: Tab,
    OrderList
  },
  data() {
    return {
      dataList: [],
      firstInFlag: false,
      isShowLongStyle: false,
      activeTab: 'flow',
      tabColor: '#4361ee'
    };
  },
  computed: {
      Module_UseIntroTips:function(){
          return checkProjectConfig.setAppThat(this).checkValue("Module_UseIntroTips",true);
      },
      Function_PackageTop:function(){
          return checkProjectConfig.setAppThat(this).checkValue("Function_PackageTop",true);
      },
      isRegAndLogin() {
          let isRegAndLogin = JSON.parse(localStorage.getItem('isRegAndLogin') || 'false');
          return isRegAndLogin;
      }
  },
  beforeRouteEnter(to, from, next) {
      next(vm => {
          if(from.name === 'PayResult'){
            vm.payResult = true;
            sessionStorage.setItem('payResult',true);
          }
      });
  },
  methods: {
    // tabsChange
    tabsChange(name) {
      this.activeTab = name;
      this.$nextTick(() => {
        let orderElement = document.documentElement || document.body;
        if(orderElement) orderElement.scrollTop = 0;
      })
    },
    // 剩余时间和优先按钮的样式
    setFlowStyle() {
      let limit = document.querySelector('li.timeLimit')?.offsetWidth;
      let timeNameList = document.querySelectorAll('.a_activeTime_name') || [];
      // 取最大的时间名称宽度
      let timeName = 0;
      timeNameList.forEach(item => {
        if (item?.offsetWidth > timeName) {
          timeName = item?.offsetWidth;
        }
      });
      let state = document.querySelector('.flow_state')?.offsetWidth;
      if(limit && timeName && state && limit <= timeName + state + 30) {
        this.isShowLongStyle = true;
      }
    },
    getOrderList() {
      let data = {
            flag: 0,
            queryNoUse: true,
            goodsType: "ALL",
            customerId: this._urlData['loginCustomerId'],
            goodsExtendAttrs:["hideFlowSize"]
      }
      if(sessionStorage.getItem('Module_Bind_Group') === 'true'){
        data = {
          ...data,
          imei:this._urlData?.imei
        }
      }
      this.$http
        .post({
          url: "/bss/app/orderRelation/QueryUserOfferList",
          data: {
            ...data
          }
        })
        .then(da => {
          let codeList = checkProjectConfig.setAppThat(this).checkValue("Test_Package_Codes",[]);
          if(codeList && codeList.length){
            let dataList = (da?.data?.dataList || []).filter(item => {
              return !codeList.includes(item.goodsCode);
            })
            this.dataList = this.disposalData({...da.data, dataList});
          } else {
            this.dataList = this.disposalData(da && da.data);
          }
        })
        .finally(() => {
          this.firstInFlag = true;
          // 获取到数据后，设置流量样式
          this.$nextTick(() => {
            this.setFlowStyle();
          })
        });
    },
    //整理数据结构
    disposalData(da = { dataList: [] }) {
      const that = this;
      da.dataList.forEach(item => {
        item.a_state = setState(item);
        item.a_activeTime = calcActiveTime(item);
        item.a_surplusFlow = setFlow(item);
        item.a_maxCount = setMaxCount(item);
        if(!item.effectiveTime && !item.expiryTime){
          item.isUseActive = false
        } else {
          item.isUseActive = true
        }
        goodsExtendAttrs(item,item);
      });
      //设置最大购买数量
      function setMaxCount(item) {
        let total = item.period;
        let unit = (item.attrMap && item.attrMap.period) || 1;
        return total / unit;
      }
      //设置流量
      function setFlow(item) {
        //优惠销售品
        if (item.goodsType == "DISC") {
          let da = item.accumulatedFlowList;
          da = (da && da[0]) || { totalFlow: "", accumulatedFlow: "" };
          let calculateFlow = that._math.sub(da.totalFlow, da.accumulatedFlow);
          calculateFlow = calculateFlow > 0 ? calculateFlow : 0;
          return { type: "DISC", flow: da.totalFlow, remainFlow: calculateFlow };
        }
        //流量包
        if (item.goodsType == "PKAG") return { type: "PKAG", flow: item.flowByte, remainFlow: item.surplusFlowbyte };
      }
      //设置流量包状态
      function setState({ status, inUse, topFlag }) {
        // if (status == "NOT_ACTIVATED") return "inactive";
        if (inUse == "1") return "inUse";
        if (topFlag == "1") return "isFirst";
        return "toFirst";
      }
      //计算剩余时间、有效期
      function calcActiveTime({ expiryTime, activeDeadline, createTime, periodUnit, period }) {
        period = period || 0;
        //有效期
        if (!expiryTime && !activeDeadline) {
          return {
            name: that.$t("order.validPeriod"),
            time: period + that.$t(`order.periodUnits.${periodUnit.toLowerCase()}`),
            notRed: !(periodUnit == "DAY" && period <= 3)
          };
        }
        //剩余时间
        let remainingTime = (expiryTime ? expiryTime : activeDeadline * 24 * 3600 * 1000 + createTime) - Date.now();
        return Object.assign(_calc(remainingTime), { name: that.$t("order.remainingTime") });
        function _calc(time) {
          if (time < 0) time = 0;
          //小时
          let hour = time / (3600 * 1000);
          if (hour < 1) return { time: Math.ceil(time / (60 * 1000)) + that.$t("order.periodUnits.minute") };
          if (hour < 24) return { time: Math.ceil(hour) + that.$t("order.periodUnits.hour") };
          //天
          let day = Math.ceil(time / (24 * 3600 * 1000));
          return {
            time: day + that.$t("order.periodUnits.day"),
            notRed: day > 3
          };
        }
      }

      //查询的销售品扩展属性列表
      function goodsExtendAttrs(item,{extendValVos}) {
        
        if(extendValVos && extendValVos.length){
            extendValVos.forEach( _goodsExtendAttrsItem => {  
                // 获取 attrValueList 数组  
                const attrValueList = _goodsExtendAttrsItem.attrValueList;  
                  
                // 判断attrValueList数组并获取值  
                const getValue= attrValueList && attrValueList[0];

                //a_hideFlowSize
                item['a_'+_goodsExtendAttrsItem.attrCode] = attrValueList;

                //a_getValue_hideFlowSize
                item['a_getValue_'+_goodsExtendAttrsItem.attrCode] = getValue;
            });
            
        }
      }
      return da.dataList;
    },
    e_changeState({ a_state, relationId, goodsType }) {
      this.$http
        .post({
          url: "/bss/app/orderRelation/TopPackageInst",
          data: {
            relationId,
            relationType: goodsType == "DISC" ? "2" : "1",
            imei:sessionStorage.getItem('Module_Bind_Group') === 'true' ? this._urlData?.imei : ''
          }
        })
        .then(da => {
          this.getOrderList();
        });
    },
    e_to(name) {
      this.$router.push(this.$setRouteQuery({name},this));
    },
    e_goBack() {
      sessionStorage.removeItem('orderType');
      if(this.payResult || this.$route.query.back === 'Home'){
        sessionStorage.removeItem('payResult');
        this.e_to('Home');
      } else {
        this.$router.go(-1);
      }
    },
    refresh(done) {
      this.setup().then(() => {
        setTimeout(() => {
          done();
        }, 1000);
      });
    },
    setup() {
      return new Promise((resolve, reject) => {
        this.getOrderList();

        resolve();
      });
    },
    // 跳转失效流量列表
    e_toInvalidFlow(){
      sessionStorage.removeItem('orderType');
      this.e_to("invalidFlow");
    },
    e_toDetail(data) {
      sessionStorage.removeItem('orderType');
      sessionStorage.setItem("flowDetailData", JSON.stringify(data));
      this.e_to("OrderDetail");
    },
    _math() {
      const add = (arg1, arg2) => {
        var r1, r2, m;
        try {
          r1 = arg1.toString().split(".")[1].length;
        } catch (e) {
          r1 = 0;
        }
        try {
          r2 = arg2.toString().split(".")[1].length;
        } catch (e) {
          r2 = 0;
        }
        m = Math.pow(10, Math.max(r1, r2));
        return (arg1 * m + arg2 * m) / m;
      };
      const sub = (arg1, arg2) => {
        return add(arg1, -arg2);
      };
      return {
        add,
        sub
      };
    },
    gotoBuy() {
      if(this.isRegAndLogin){
        this.$router.replace(this.$setRouteQuery({name:'Packages'},this));
      } else {
        this.$router.replace(this.$setRouteQuery({path: '/Home'},this));
      }
    },
  },
  filters: {
    filterFlow(da) {
      if (da == 0) return "0MB";
      if (!da) return "";
      let flow = keepTwodecimalFixed(da < 1000 ? da : da / 1024);
      let langType = cookie.getCookie('langType')
      // 部分欧洲国家小数点采取 ， 形式
      let country = ['es-ES','pt-PT','de-DE','fr-FR']; 
      let showFlow = flow.toString().replace(/\.00$|0$/, "")
      if(country.includes(langType)){
          showFlow = showFlow.replace('.',',')
      }
      return `${showFlow}${(da < 1000 && "MB") || "GB"}`;
    }
  },
  created(){
    this._urlData = JSON.parse(sessionStorage.getItem('urlData') || '{}');
  },
  mounted() {
    this.setup();
    this._math = this._math();
    if(sessionStorage.getItem('custom-theme')){
      this.tabColor = JSON.parse(sessionStorage.getItem('custom-theme')).primary || this.tabColor;
    }    
    sessionStorage.getItem('orderType') === 'order' ? this.activeTab = 'order' : this.activeTab = 'flow';
    sessionStorage.getItem('payResult') === 'true' ? this.payResult = true : this.payResult = false;
  }
};
</script>

<style lang="less" scoped>
@import "css/index.less";
</style>